import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n';
import App from './App';
import './index.css';
import { installGlobalErrorReporting } from './utils/errorReporting';

import { clearLazyChunkReloadFlag, installLazyChunkRecovery } from './lazyWithRetry';

installGlobalErrorReporting();
installLazyChunkRecovery();
clearLazyChunkReloadFlag();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

